import type { ProviderAuthenticationIntentResponse, UniLoginProvider } from '@unipile/types';
import { useHostedAuthSession } from '../../../hooks/useHostedAuthSession';
import { useUniLoginFlow } from '../../../hooks/useUniLoginFlow';
import { UniLoginScreen } from './UniLoginScreen';

export function UniLoginForm({
  provider,
  onSuccess,
  onError,
  onCancel,
}: {
  provider: UniLoginProvider;
  onSuccess: (data: ProviderAuthenticationIntentResponse) => void;
  onError: (error: unknown) => void;
  onCancel: () => void;
}) {
  const { data: session } = useHostedAuthSession();
  const { state, request, browser, retry, restart } = useUniLoginFlow({ provider, onSuccess, onError });

  return (
    <UniLoginScreen
      state={state}
      request={request}
      browser={browser}
      publisherName={request?.publisher_name?.trim() || session?.brand_name?.trim()}
      onRetry={retry}
      onRestart={restart}
      onCancel={onCancel}
    />
  );
}
